<template>
    <v-card>
        <v-form ref="commonObjectForm" @submit.prevent v-model="formValid" :lazy-validation="true">
            <v-card-title>{{ `${$props.commonObject.object_name ? 'Edit' : 'New'} Common Object` }}</v-card-title>
            <v-card-text>
                <v-row dense no-gutters>
                    <v-col cols="12">
                        <v-text-field label="Object Name" color="#c42111" v-model="$props.commonObject.object_name" outlined :rules="[validation.required($props.commonObject.object_name)]" />
                    </v-col>
                    <v-col cols="12">
                        <v-textarea label="Description" color="#c42111" v-model="$props.commonObject.object_description" outlined />
                    </v-col>
                </v-row>

                <!-- <v-btn class="mr-3" color="#c42111" @click="saveClick">Save</v-btn>
                <v-btn class="mr-3" color="#c42111" @click="$emit('cancel')">Cancel</v-btn> -->
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text class="mr-3" @click="$emit('cancel')">Cancel</v-btn>
                <v-btn text class="mr-0" @click="saveClick">Save</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
export default {
    name: 'CommonObjectEdit',
    props: ['commonObject'],
    components: {

    },
    data: () => ({
        formValid: true,
        validation: {
            required: (value) => (value ? true : false || "Required field")
        }
    }),

    computed: {

    },

    methods: {
        saveClick: function() {
            if(this.$refs.commonObjectForm.validate()) {
                this.$emit('save', this.$props.commonObject);
            }
        }
    },

    mounted() {

    }

  
};
</script>
